import { render, staticRenderFns } from "./imgCol.vue?vue&type=template&id=56e96c40&scoped=true"
import script from "./imgCol.vue?vue&type=script&lang=js"
export * from "./imgCol.vue?vue&type=script&lang=js"
import style0 from "./imgCol.vue?vue&type=style&index=0&id=56e96c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e96c40",
  null
  
)

export default component.exports